import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import IndexEn from './views/IndexEn.vue'
import PoliticaDeConfidentialitate from './views/PoliticaDeConfidentialitate.vue';
import PoliticaDeCookies from './views/PoliticaDeCookies.vue'
import TermeniSiConditii from './views/TermeniSiConditii.vue'
Vue.use(Router)

export default new Router({
  scrollBehavior() {
    return { x: 0, y: 0 };
  },  
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        title: 'eematico Toys | jucarii pentru invatat, de asamblat si de explorat',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys, jucarii din lemn pentru copii mesterite in atelierul eematico, invatare prin joaca, invatare practica, joaca e treaba serioasa'
          },
          {
            property: 'og:description',
            content: 'eematico Toys, jucarii din lemn pentru copii mesterite in atelierul eematico, invatare prin joaca, invatare practica, joaca e treaba serioasa'
          }
        ]  
        }    
    },
    {
      path: '/en',
      name: 'indexEn',
      component: IndexEn,
      meta: {
        title: 'eematico Toys | toys to learn, to make and to explore',
        metaTags: [
          {
            name: 'description',
            content: 'eematico toys, wooden toys for children manufactured in eematico studio, learning through play, hands-on education, playing is a serious matter'
          },
          {
            property: 'og:description',
            content: 'eematico toys, wooden toys for children manufactured in eematico studio, learning through play, hands-on education, playing is a serious matter'
          }
        ]      
      }
    },    
    {
      path:'/politica-de-confidentialitate',
      name:'politica-de-confidentialitate',
      component: PoliticaDeConfidentialitate,
      meta: {
        title: 'eematico Toys | Politica de Confidentialitate',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys | Politica de Confidentialitate'
          },
          {
            property: 'og:description',
            content: 'eematico Toys | Politica de Confidentialitate'
          }
        ]       
      }
    },
    {
      path:'/politica-de-cookies',
      name:'politica-de-cookies',
      component: PoliticaDeCookies,
      meta: {
        title: 'eematico Toys | Politica de Cookies',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys | Politica de Cookies'
          },
          {
            property: 'og:description',
            content: 'eematico Toys | Politica de Cookies'
          }
        ]       
      }
    },
    {
      path:'/termeni-si-conditii',
      name:'termeni-si-conditii',
      component: TermeniSiConditii,
      meta: {
        title: 'eematico Toys | Termeni si Conditii',
        metaTags: [
          {
            name: 'description',
            content: 'eematico Toys | Termeni si Conditii'
          },
          {
            property: 'og:description',
            content: 'eematico Toys | Termeni si Conditii'
          }
        ]       
      }
    }
    

    // {
    //   path: '/en',
    //   name: 'about',
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // },
  ]
})
